export default {
  token: process.env.FRESH_CHAT_TOKEN,
  host: process.env.FRESH_CHAT_HOST,
};
